/**
 * Display helpers: round numeric values up to the next whole unit (Math.ceil).
 */

export function ceilNextInt(value) {
  if (value === '' || value === null || value === undefined) return value;
  const n = typeof value === 'number' ? value : parseFloat(String(value).replace(/,/g, ''));
  if (!Number.isFinite(n)) return value;
  return Math.ceil(n);
}

/** Percent strings like "95.77%" or numbers → "96%" */
export function ceilPercentageLabel(value) {
  if (value === '' || value === null || value === undefined) return value;
  const n = parseFloat(String(value).replace('%', '').trim());
  if (!Number.isFinite(n)) return value;
  return `${Math.ceil(n)}%`;
}

/** Values such as "₹14,617.84" or "\u20b91461787.84" */
export function ceilRupeeLabel(value) {
  if (value === '' || value === null || value === undefined) return value;
  const s = String(value);
  const stripped = s.replace(/,/g, '').replace(/\u20b9/g, '').replace(/₹/g, '').trim();
  const n = parseFloat(stripped);
  if (!Number.isFinite(n)) return value;
  const ceiled = Math.ceil(n);
  if (/\u20b9|₹/.test(s)) return `\u20b9${ceiled.toLocaleString('en-IN')}`;
  return String(ceiled);
}

/** Scrap / composite strings: ceil rupee amounts and standalone decimals */
export function ceilMixedQtyValue(value) {
  if (value === '' || value === null || value === undefined) return value;
  if (typeof value === 'number' && Number.isFinite(value)) return Math.ceil(value);
  if (typeof value !== 'string') return value;
  let out = value.replace(/([\u20b9₹])\s*([\d,.]+)/g, (_, sym, rawNum) => {
    const n = parseFloat(String(rawNum).replace(/,/g, ''));
    return Number.isFinite(n) ? `${sym}${Math.ceil(n).toLocaleString('en-IN')}` : `${sym}${rawNum}`;
  });
  out = out.replace(/\b\d+\.\d+\b/g, (token) => {
    const n = parseFloat(token);
    return Number.isFinite(n) ? String(Math.ceil(n)) : token;
  });
  return out;
}

/** Dashboard-style fields that may be number or string with % */
export function ceilPercentUi(value) {
  if (value === null || value === undefined || value === '') return 0;
  const n = typeof value === 'number' ? value : parseFloat(String(value).replace(/%/g, '').replace(/,/g, '').trim());
  if (!Number.isFinite(n)) return 0;
  return Math.ceil(n);
}

/** Counts / hours shown without a % suffix */
export function ceilNumberUi(value) {
  if (value === null || value === undefined || value === '') return 0;
  const n = typeof value === 'number' ? value : parseFloat(String(value).replace(/,/g, '').trim());
  if (!Number.isFinite(n)) return 0;
  return Math.ceil(n);
}
